const tabs = () => {
  const $historyItems = $('.history-item');
  const $tabLinks = $('.tab-link');
  $historyItems.hide();
  $historyItems.filter('[data-year="1940"]').show();
  $tabLinks.on('click', function() {
    const year = $(this).data('year');
    $historyItems.hide();
    $tabLinks.removeClass('--primary').addClass('--second');
    $historyItems.filter(`[data-year="${year}"]`).show();
    $tabLinks.filter(`[data-year="${year}"]`).removeClass('--second').addClass('--primary');
  });
};
export { tabs };